import { ThreeDots } from '@agney/react-loading'

import appSettings from '@/config/appSettings'
import { cn } from '@/utils/cn'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Spinner = ThreeDots as any

interface StatusMessageProps {
  text?: string
  error?: boolean
  loading?: boolean
}

const StatusMessage = ({
  text,
  error = false,
  loading = false,
}: StatusMessageProps) => (
  <div className='flex flex-1 items-center justify-center'>
    {loading ? (
      <div className='flex flex-col items-center justify-center gap-4'>
        <img
          src={appSettings.logo}
          alt={`${appSettings.name} logo`}
          className='h-16 w-auto rounded-lg'
        />
        <div className='text-text-tertiary'>
          <Spinner width={60} />
        </div>
      </div>
    ) : (
      <span
        className={cn('text-sm', error ? 'text-red-400' : 'text-text-tertiary')}
      >
        {text}
      </span>
    )}
  </div>
)

export default StatusMessage
